export default {
  guestTitle: '登錄 / 註冊',
  guestDesc: '登錄後解鎖充值、返水、VIP、收藏等全部功能',
  copy: '複製',
  refreshBalance: '刷新餘額',
  balanceRefreshed: '餘額已刷新',
  deposit: '充值',
  withdraw: '提現',
  transfer: '額度轉換',
  recover: '餘額找回',
  vipTitle: 'VIP 俸祿特權',
  vipSub: '日 · 周 · 月俸祿,晉級領彩金',
  vipGo: '查看特權 ▶',
  vipGap: '距 V{level} 還需充值 {amt}',
  vipMax: '已達最高等級',

  rewardTitle: '獎勵中心',
  rewardPending: '優惠 · 任務 · 返水 · 俸祿,{n} 個獎勵待領取',
  rewardDone: '優惠 · 任務 · 返水 · 俸祿,今日獎勵已領完',
  claim: '去領取',
  doTask: '去做任務',
  bets: '遊戲報表',
  betOrders: '我的注單',
  betTotalStake: '下注總金額',
  betTotalWin: '中獎總金額',
  betCount: '下單注數',
  betStakeAmt: '下單金額',
  betWinAmt: '中獎金額',
  betViewDetail: '查看詳情 ›',
  betEmpty: '該時段暫無投注',
  betLoading: '加載中…',
  betLoadMore: '加載更多',
  betNoMore: '沒有更多了',
  betTime: '下注時間',
  betContent: '下注內容',
  betStatus: '訂單狀態',
  betOrderNo: '訂單編號',
  betWon: '中獎',
  betLost: '未中獎',
  betPending: '待結算',
  betRefunded: '已退款',
  betTypeSlots: '電子',
  betTypeLive: '真人',
  betTypeSport: '體育',
  betTypeOriginal: '原創',
  betTypeChess: '棋牌',
  betTypeFish: '捕魚',
  payout: '收款賬戶',
  security: '安全中心',
  securityOn: '已開啟',
  kyc: '身份認證 KYC',
  kycNone: '未認證',
  kycPending: '審核中',
  kycRejected: '未通過',
  kycVerified: '已認證',
  refer: '推廣賺錢',
  referTip: '佣金最高 25%',
  language: '語言 · Language',
  logout: '退出登錄',
  logoutConfirm: '確認退出當前賬號?餘額與記錄仍安全保存,重新登錄即可查看。',
  cancel: '取消',
  langTitle: '選擇語言',
  langComing: '即將上線',
  comingSoon: '功能即將開放',
  recoverScanning: '正在掃描場館餘額…',
  recoverEmpty: '各場館暫無滯留餘額',
  recoverOk: '已即時回收 {amt}',
  recoverTickets: '{n} 個場館已轉代位下分，後臺處理中',
  recoverOkAndTickets: '已即時回收 {amt}，另有 {n} 個場館代位處理中',

  // —— 額度轉換 ——
  tfAuto: '自動額度轉換',
  tfAutoDesc: '關閉後進場前手動轉入所需額度,資金不整存三方',
  tfAutoAria: '自動額度轉換開關',
  tfOut: '轉出',
  tfIn: '轉入',
  tfCentral: '中心錢包',
  tfVenue: '三方場館',
  tfAvailable: '可用',
  tfVenueBal: '場館餘額',
  tfAmtPlaceholder: '自定義轉換金額',
  tfAll: '全部',
  tfSelectVenue: '選擇場館',
  tfSearchVenue: '搜索場館名稱',
  tfAllCats: '全部',
  tfMaint: '維護中',
  tfPending: '代位下分中',
  tfMapped: '¥ 計價',
  tfEmptyVenue: '未找到相關場館',
  tfLoading: '正在加載場館…',
  tfUnknown: '--',
  tfNote:
    '單筆最低 {min} · 實時到賬、免手續費 · 維護中場館暫停轉換;場館餘額無法轉出時,可用「餘額找回」一鍵代位下分。',
  tfConfirmIn: '確認轉入 {name}',
  tfConfirmOut: '確認轉出 {name}',
  tfBusy: '轉換中…',
  tfMainAcct: '{code} 主賬戶',
  tfSwapAria: '切換轉換方向',
  tfErrMaint: '{name} 維護中,暫停轉換',
  tfErrPend: '{name} 代位下分處理中,暫不可轉換',
  tfErrAmt: '請輸入有效金額',
  tfErrMin: '單筆最低 {min}',
  tfErrCentral: '中心錢包可用不足(可轉 {amt})',
  tfErrVenue: '{name} 場館餘額不足(可轉 {amt})',
  tfErrUnknown: '{name} 場館餘額暫未查得,請稍後重試或使用餘額找回',
  tfErrTimeout: '轉換結果未知,請勿重複操作,稍後刷新餘額確認',
  tfOkIn: '已轉入 {name} {amt}',
  tfOkOut: '已從 {name} 轉出 {amt}',
  tfAutoOn: '已開啟自動額度轉換:進入場館自動攜帶餘額',
  tfAutoOff: '已關閉自動轉換:進場前請手動轉入額度',
  tfEnterHint: '進入「{name}」:本場館內計價符號為 ¥,= {code} 等值(1:1),進出等值可逆',

  // —— 消息通知 ——
  ntMarkAll: '全部已讀',
  ntAllRead: '全部消息已讀',
  ntEmpty: '暫無消息通知',
  ntLoading: '加載中…',
  ntNote: '最多保留最近 90 天站內消息；資金到賬以錢包賬變為準。',
  ntDetailTitle: '消息詳情',
  ntKindFund: '資金通知',
  ntKindAct: '活動通知',
  ntKindSys: '系統通知',
  ntViewAria: '查看{title}',
  ntMissing: '消息不存在或已下架',
  ntTabAll: '全部',
  ntTabFund: '資金',
  ntTabAct: '活動',
  ntTabSys: '系統',
}
